import { report } from './index';
export function buryingPoint (title, axios) {
	let itemid = ''
	if (['不删档预约', '新版本预约', '周年预约', '周年庆预约'].indexOf(title) >= 0) {
		itemid = '12017'
	}
	report(itemid)
}



// WEBPACK FOOTER //
// ./src/components/actModules/h5/templates/buryingPoint/makeanAppointment.js